import { PageWrapper } from 'pages/_layouts/PageWrapper';
import { FC } from 'react';
import { FSForm } from 'widgets/integrations/FtpSettings/Form';
import { FSHeader } from 'widgets/integrations/FtpSettings/Header';

export const FtpSettings: FC = () => {
	return (
		<PageWrapper>
			<FSHeader />
			<FSForm />
		</PageWrapper>
	);
};
